import type { QueryClient } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { getEligibility, useProductOfferStore } from "@/sales-tools";
import { useLogger } from "@/sdk";

import type { EligibilityRequest } from "../types";

const QUERY_KEY = "sales-eligibility";

export const useEligibility = (request: EligibilityRequest, isEnabled = true) => {
    const logger = useLogger({ module: "useEligibility", supportTeam: "sales" });

    const { data, isLoading, isError, error } = useQuery({
        queryKey: [
            QUERY_KEY,
            request.customerMdn,
            request.sessionId,
            request.customer?.accountNumber,
            request.eligibilityAttributes?.currentSubscriptions,
        ],
        queryFn: async () => {
            return getEligibility(logger, {
                ...request,
            });
        },
        staleTime: Infinity,
        gcTime: Infinity,
        retry: 1,
        enabled: isEnabled,
    });

    useEffect(() => {
        if (!data?.meta) return;
        useProductOfferStore.getState().updateEligibilityMetaBySessionId(request.sessionId, data.meta);
    }, [request.sessionId, data?.meta]);

    return { data, isLoading, isError, error };
};

export const clearEligibilityQueryCache = (queryClient: QueryClient, sessionId: string) => {
    queryClient.removeQueries({
        predicate: (query) => query.queryKey.includes(QUERY_KEY) && query.queryKey.includes(sessionId),
    });
};
